import { GroupModel, GroupModelAPI } from '../../../../models';

export const getGroupListadapter = (responseAPI: GroupModelAPI[]): GroupModel[] => {
    return responseAPI
        ? responseAPI.map((group) => {
              return {
                  id: group.id,
                  name: group.name,
                  description: group.description,
                  isActive: group.isActive,
              };
          })
        : [];
};
